module.exports = __webpack_public_path__ + "static/media/House 4.598bf4b7.svg";